import React, {Component} from 'react';
import {Field, reduxForm, submit} from 'redux-form';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

const renderTextField = ({input, meta: {touched, error, invalid}, ...custom}) => {
    return (touched && invalid)
        ? <TextField error={invalid}
                     helperText={error}
                     onChange={(event, index, value) => input.onChange(value)}
                     {...input}
                     {...custom} />
        : <TextField onChange={(event, index, value) => input.onChange(value)}
                     {...input}
                     {...custom} />;
};

const renderSelect = ({input, meta: {touched, error, invalid}, ...custom}) => {
    return (touched && invalid)
        ? <FormControl fullWidth={true}>
            <InputLabel error={invalid}>Empresa</InputLabel>
            <Select error={invalid}
                    onChange={(event, index, value) => input.onChange(value)}
                    {...input}
                    {...custom}>
                <MenuItem value="SUPRASYS">SUPRASYS</MenuItem>
                <MenuItem value="INFORMECE">INFORMECE</MenuItem>
            </Select>
            <FormHelperText error={invalid}>{error}</FormHelperText>
        </FormControl>
        :
        <FormControl fullWidth={true}>
            <InputLabel>Empresa</InputLabel>
            <Select onChange={(event, index, value) => input.onChange(value)}
                    {...input}
                    {...custom}>
                <MenuItem value="SUPRASYS">SUPRASYS</MenuItem>
                <MenuItem value="INFORMECE">INFORMECE</MenuItem>
            </Select>
        </FormControl>;
};

class EmpresaForm extends Component {

    render() {
        const {handleSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <Field type="text" name="nome" label="Nome" component={renderTextField} fullWidth={true} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field type="text" name="cnpj" label="CNPJ" component={renderTextField} fullWidth={true} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field name="contrato" component={renderSelect}/>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = ['nome', 'cnpj', 'contrato'];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Campo obrigatório';
        }
    });

    return errors;
};

export default reduxForm({form: 'empresaForm', onSubmit: submit, validate})(EmpresaForm);


// WEBPACK FOOTER //
// src/components/EmpresaForm.js